import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PPendingChangesDialogComponent, UnsavedChangesResult } from '../ui/dialogs/p-pending-changes-dialog.component';
import { PDialogService } from '@frontend-site/ui/components';
import { SaveableEntityComponent } from '../interfaces/saveable-entity';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PendingChangesService {
    constructor(public dialog: PDialogService) {}

    handle(
        component: SaveableEntityComponent | null,
        currentRoute?: ActivatedRouteSnapshot,
        currentState?: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean> {
        if (!component?.hasUnsavedChanges(currentRoute, currentState, nextState)) {
            return of(true);
        }

        const dialogRef = this.getOrCreatePendingChangesDialog(component.isValidEntity());

        return dialogRef.afterClosed().pipe(
            switchMap((dialogResult) => {
                switch (dialogResult) {
                    case UnsavedChangesResult.SAVE: {
                        const result: Subject<void | boolean> = component.saveBeforeRoute(); // TODO: change return value to be Observable<boolean>
                        return this.convertToCanDeactivate(result);
                    }
                    case UnsavedChangesResult.DISCARD:
                        return component.discardChanges ? component.discardChanges().pipe(map(() => true)) : of(true);
                    case UnsavedChangesResult.STAY:
                    default:
                        return of(false);
                }
            })
        );
    }

    private convertToCanDeactivate(result: Subject<void | boolean>) {
        return result.pipe(map((result: void | boolean) => (typeof result === 'boolean' ? result : true)));
    }

    private getOrCreatePendingChangesDialog(isValidEntity: boolean) {
        let dialogRef;

        if (this.dialog.hasOpenDialog()) {
            dialogRef = this.dialog.openDialogRef;
        } else {
            dialogRef = this.dialog.open(PPendingChangesDialogComponent, {
                panelClass: 'p-dialog-medium',
                data: { isValidEntity: isValidEntity }
            });
        }

        return dialogRef;
    }
}
